"use client";
import { ButtonTransparent, MdButton } from "@/stories/Button.stories";
import Button from "../Cards/Button";
import Link from "next/link";
import Image from "next/image";
import SideBySideText from "../Text/SideBySideText";
import Triangles from "../Triangles";
import Testimonial from "../Text/Testimonial";
import { TestimonialYellow } from "@/stories/Testemonial.stories";
import { sendGTMEvent } from "../Analytics";

export default function LiveEventsLayout() {
    return (
        <>
            <div className="bg-yellow flex justify-center">
                <div className="container w-full space-y-1 px-3 lg:px-20 py-10 flex-col gap-2 inline-flex">
                    <Testimonial
                        backgroundColor={TestimonialYellow.args?.backgroundColor}
                        description="Setzt Energiefelder instand, ohne dabei Energie zu senden"
                        text="Wissen lebt, wenn man darüber spricht."
                        name="Rico Brunner"
                        differentTextColor={TestimonialYellow.args?.differentTextColor}
                        textColor={TestimonialYellow.args?.textColor}
                        icon={TestimonialYellow.args?.icon}
                        wordsInDifferentColor={["Wissen", "lebt,"]}
                    />
                </div>
            </div>
            <div className="bg-yellow">
                <Triangles backgroundColor="bg-turquoise" buttomToTop={false} />
            </div>
            <div className="bg-turquoise md:px-20 w-full space-y-1 px-3 lg:px-20 lg:py-10 flex-col gap-2 inline-flex">
                <div className="lg:pl-36">
                    <SideBySideText
                        backgroundColor="bg-turquoise"
                        elementRight={
                            <div className="">
                                <Image
                                    alt=""
                                    width={700}
                                    height={1400}
                                    src="/images/bookImg.png"
                                    className="rounded-md"
                                />
                            </div>
                        }
                        elementLeft={
                            <div className="flex flex-col leading-20  lg:w-1/2 space-y-3">
                                <div>
                                    <div className=" text-black lg:text-[80px] text-[40px] font-bold  lg:leading-[80px] leading-[52px]">
                                        Lerne meine Methode im Buch kennen
                                    </div>
                                    <div className=" text-black lg:text-2xl  text-xl font-bold  lg:leading-10 leading-7">
                                        In meinem Buch «Energiefeld-Instandsetzung»
                                        beschreibe ich meine dynamische Arbeitsweise. Ich
                                        berichte sowohl von Erfahrungen als auch von
                                        Schlüsselmomenten, die ich im Zuge meiner
                                        Tätigkeit hatte.
                                    </div>
                                </div>
                                <div className=" flex-col justify-center items-start inline-flex">
                                    <div className="justify-start space-x-2 inline-flex">
                                        <div className="text-black text-xl lg:text-xl1 font-bold  leading-8.5">
                                            CHF{" "}
                                        </div>
                                        <div className="text-center text-black text-2xl lg:text-xl3 font-bold  leading-10">
                                            17.40.
                                        </div>
                                    </div>
                                    <div className="text-black text-lg lg:text-xl1 font-normal  leading-8.5">
                                        Buch: 14.90 & Porto/Verpackung: 2.50
                                    </div>
                                </div>
                                <div className=" flex-col justify-center items-start inline-flex">
                                    <div className="justify-start inline-flex space-x-2">
                                        <div className="text-black text-xl lg:text-xl1 font-bold  leading-8.5">
                                            EURO{" "}
                                        </div>
                                        <div className="text-center text-black text-2xl lg:text-xl3 font-bold  leading-10">
                                            {" "}
                                            24.80
                                        </div>
                                    </div>
                                    <div className="text-black text-lg lg:text-xl1 font-normal  leading-8.5">
                                        Buch: 13.80 & Porto/Verpackung/Verzollung: 11.00
                                    </div>
                                </div>
                                <div>
                                    <div className="text-black text-xl1 font-bold  leading-7">
                                        ISBN 978-3-033-03890-5
                                    </div>
                                    <div className="space-y-2 ">
                                        <div className="space-x-2 text-black text-lg lg:text-xl1 font-normal  ">
                                            <span>Bei</span>

                                            <span className="text-black text-lg lg:text-xl1 font-normal  underline ">
                                                <Link
                                                    href={
                                                        "https://www.orellfuessli.ch/shop/home/artikeldetails/A1032428253"
                                                    }
                                                >
                                                    orellfüssli
                                                </Link>
                                            </span>
                                            <span>bestellen.</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="lg:flex md:flex gap-6 text-center space-y-4 md:space-y-0 lg:space-y-0 lg:py-0">
                                    <Button
                                        size={MdButton.args?.size}
                                        text="Buch direkt bestellen"
                                        textColor={MdButton.args?.textColor}
                                        textSize={MdButton.args?.textSize}
                                        paddings={"py-5 px-2"}
                                        backgroundColor={MdButton.args?.backgroundColor}
                                        as="a"
                                        href="/de/buchbestellung"
                                        onClick={() => {
                                            sendGTMEvent({
                                                event: "cta_click",
                                                section_title:
                                                    "Lerne meine Methode im Buch kennen",
                                                section_index: "3",
                                                cta_text: "Buch direkt bestellen",
                                                cta_link: `${process.env.NEXT_PUBLIC_URL}/de/buchbestellung`,
                                            });
                                        }}
                                    />
                                    <Button
                                        text="Leseprobe"
                                        as="a"
                                        newTab={true}
                                        href="/pdfs/Leseprobe_Energiefeld-instandsetzung.pdf"
                                        textColor={ButtonTransparent.args?.textColor}
                                        backgroundColor="bg-nocolor"
                                        border={ButtonTransparent.args?.border}
                                        size={MdButton.args?.size}
                                        paddings="px-[5.6rem] py-4"
                                        onClick={() => {
                                            sendGTMEvent({
                                                event: "cta_click",
                                                section_title:
                                                    "Lerne meine Methode im Buch kennen",
                                                section_index: "3",
                                                cta_text: "Leseprobe",
                                                cta_link: `${process.env.NEXT_PUBLIC_URL}/pdfs/Leseprobe_Energiefeld-instandsetzung.pdf`,
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                        }
                    />
                </div>
            </div>
            <div className="bg-turquoise">
                <Triangles backgroundColor="bg-white" buttomToTop={true} />
            </div>
        </>
    );
}
